module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point02_03_miyakoblue-8e6fdde412a0795136beea6031e5cf37.jpg";